enum FrontLightsMode {
  On = "On",
  Off = "Off",
  Flash = "Flash",
}

export default FrontLightsMode;
